import React, { useState } from "react";

// Reemplazo del window.prompt() nativo del navegador — mismo lenguaje visual
// que el resto de los modales de la app (tarjeta blanca, botón navy), para
// pedir un texto corto (ej. motivo de un rechazo) sin la ventanita cruda del
// sistema operativo.
// `contenido` (opcional) se muestra entre la pregunta y el cuadro de texto,
// por ejemplo una tabla con los productos afectados; `ancho` ensancha el modal.
function PromptModal({ titulo, etiqueta, contenido, ancho, placeholder, textoBoton = "Aceptar", procesando, onCancelar, onAceptar }) {
  const [valor, setValor] = useState("");

  if (!etiqueta) return null;

  const confirmar = () => {
    const texto = valor.trim();
    if (!texto) return;
    onAceptar(texto);
  };

  return (
    <div style={styles.overlay} onClick={procesando ? undefined : onCancelar}>
      <div style={{ ...styles.modal, ...(ancho ? { maxWidth: ancho } : {}) }} onClick={(e) => e.stopPropagation()}>
        <h3 style={styles.titulo}>{titulo || "Motivo"}</h3>
        <p style={styles.etiqueta}>{etiqueta}</p>
        {contenido}
        {contenido && <label style={styles.etiquetaMotivo}>Motivo</label>}
        <textarea
          value={valor}
          onChange={(e) => setValor(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) confirmar();
          }}
          autoFocus
          rows={3}
          placeholder={placeholder || "Escribe el motivo..."}
          style={styles.input}
          disabled={procesando}
        />
        <div style={styles.pie}>
          <button type="button" onClick={onCancelar} disabled={procesando} style={styles.botonCancelar}>
            Cancelar
          </button>
          <button
            type="button"
            onClick={confirmar}
            disabled={procesando || !valor.trim()}
            style={styles.botonAceptar}
          >
            {procesando ? "Guardando..." : textoBoton}
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(11,60,96,0.55)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2100,
    padding: "1rem",
  },
  modal: {
    background: "#fff",
    borderRadius: 16,
    padding: "1.4rem 1.5rem 1.2rem",
    width: "100%",
    maxWidth: 440,
    boxShadow: "0 16px 48px rgba(11,60,96,0.35)",
  },
  titulo: { margin: "0 0 0.5rem", fontSize: "1.05rem", color: "var(--tema-titulo, #0b3c60)" },
  etiqueta: { margin: "0 0 0.6rem", fontSize: "0.88rem", color: "#3d4a5c" },
  etiquetaMotivo: { display: "block", margin: "0 0 0.3rem", fontSize: "0.76rem", fontWeight: 700, color: "#5b6472", textTransform: "uppercase", letterSpacing: "0.02em" },
  input: {
    width: "100%",
    boxSizing: "border-box",
    border: "1px solid #d3d9df",
    borderRadius: 8,
    padding: "0.6rem 0.7rem",
    fontFamily: "inherit",
    fontSize: "0.88rem",
    resize: "vertical",
  },
  pie: { display: "flex", justifyContent: "flex-end", gap: "0.6rem", marginTop: "1.1rem" },
  botonCancelar: {
    background: "#fff",
    color: "var(--tema-titulo, #0b3c60)",
    border: "1px solid #d3d9df",
    borderRadius: 8,
    padding: "0.55rem 1.1rem",
    fontSize: "0.88rem",
    fontWeight: 600,
    cursor: "pointer",
  },
  botonAceptar: {
    background: "var(--tema-titulo, #0b3c60)",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    padding: "0.55rem 1.3rem",
    fontSize: "0.88rem",
    fontWeight: 700,
    cursor: "pointer",
  },
};

export default PromptModal;
